/* eslint-disable */
import { rpc } from '../service/index';
import { M } from '../service/grpc';
import { getToken } from '../service/helper';

const authWhiteList = ['index', "step", 'signin', 'config', 'kind', 'index-industry', 'index-about', 'feature', 'agent', 'promotion', 'industry-info'];

export const auth = async route => {
  const res = authWhiteList.includes(route.name) || getToken();
  return res;
};

export const auth1 = route => {
  const res = authWhiteList.includes(route.name);
  return res;
};

let store = null;
export const getCachedStore = async () => {
  if (store !== null) return store;
  const res = await rpc('StoreAuthService.GetStore', M('Token', { token: getToken() }));
  store = res;
  return store;
};

// 获取当前用户的can列表
export const getCanList = async () => {
  try {
    var a = await rpc('StoreAuthService.GetAuth', M('Token', { token: getToken() }));
    var r = await rpc(
      'StoreStoreRoleService.GetStoreRole',
      M('IDWithTokenRequest', {
        id: a.storeroleid,
        token: M('Token', { token: getToken() })
      })
    );
    if (r.name !== 'Admin') {
      return r.cansList;
    }
      var kind = (await getCachedStore()).kind;
      var cansList = [];
      if(kind == 0){
          cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "配送费管理",
              "轮播图管理",
              "小程序码管理",
              "打印机管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
      if(kind == 1){
          cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "小程序码管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
      if(kind == 2){
          cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "名师名生管理",
              "配送费管理",
              "预约管理",
              "报名管理",
              "轮播图管理",
              "小程序码管理",
              "打印机管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
      if(kind == 3){
          cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "小程序码管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
      if(kind == 4){
          cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "周期购管理",
              "配送费管理",
              "轮播图管理",
              "小程序码管理",
              "打印机管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
      if(kind == 6){
          cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "配送费管理",
              "轮播图管理",
              "打印机管理",
              "小程序码管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
      if(kind == 7){
          cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "配送费管理",
              "打印机管理",
              "小程序码管理",
              "轮播图管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
      return cansList;
  } catch (e) {
    if (e.message.indexOf('no rows') !== -1) {
      delToken();
      throw new Error('请刷新浏览器');
      window.location.href = '/';
    }
  }
};
